import abstractModel from "../../core/ShopModel";

const resource = 'retailers/products';

const model = abstractModel(resource);

model.getOne = async (params) => {
  const newResource = `${resource}/${params.id}`;

  return model.get({}, { path: newResource });
};

model.checkSku = (params = {}) => model.post(params, { path: `${resource}/check_sku` });

model.getSelectProducts = (params = {}) => {
  const { searchText = '', productsQuery = '', ...rest } = params;
  const filters = [`q[title_or_sku_i_cont]=${encodeURIComponent(searchText)}`];
  if (productsQuery) filters.push(productsQuery);

  return model.get(rest, { path: 'retailers/select_products', filters: filters.join('&') });
};

export default model;
